import { useQuery } from "@tanstack/react-query";
import { getMe } from "../api";
import { qk } from "../../../lib/queryKeys";

export const useSessionQuery = () => {
  return useQuery({
    queryKey: qk.me(),
    queryFn: getMe,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};

export const useSession = useSessionQuery;
